import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconPhoneFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { useLocation, Link } from 'react-router-dom';

import { InnerLayout } from '../../InnerLayout/InnerLayout';

export const ApplicantCallPage = () => {
    const { search } = useLocation();

    useEffect(() => {
        tracking.ampli.fundingRequirementsApplicantCallViewed({
            version: '2.0'
        });
    }, []);

    return (
        <InnerLayout
            title={
                <FormattedMessage
                    id="_.funding_requirements.applicant_call_step.title"
                    defaultMessage="Give us a quick call"
                />
            }
            subheading={
                <FormattedMessage
                    id="_.funding_requirements.applicant_call_page.subheading"
                    defaultMessage="You’re nearly there. Based on your application so far, you’ll need to call your Account Manager to finish the last step."
                />
            }
        >
            <div className="mt-2xl flex items-center gap-m">
                <IconPhoneFilled className="text-xl text-primary-10" />
                <a
                    href="tel:+442037780105"
                    className="text-l font-med text-primary-10"
                >
                    <FormattedMessage
                        id="_.funding_requirements.applicant_call_page.phone_number"
                        defaultMessage="020 3778 0105"
                    />
                </a>
            </div>

            <div className="mt-2xl">
                <Link
                    to={maintainStateKey({
                        pathname: '/funding-requirements/',
                        search
                    })}
                >
                    <Button variant="primary-rounded">
                        <FormattedMessage
                            id="_.funding_requirements.applicant_call_page.return_button"
                            defaultMessage="Return to list"
                        />
                    </Button>
                </Link>
            </div>
        </InnerLayout>
    );
};
